if (cleverapps.styles.CrossPromoWindow) {
    cleverapps.overrideStyles(cleverapps.styles.CrossPromoWindow, {
        window: {
            padding: {
                bottom: 20
            }
        }
    });
}
